import type { Maybe } from '@/frontend-types'

export const getTimeAgo = (date: Maybe<string | Date>): string => {
	if (!date) return ''

	const now = new Date()
	const targetDate = new Date(date)

	// For date-only comparisons, set both dates to start of day (00:00:00)
	const nowStartOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	const targetStartOfDay = new Date(
		targetDate.getFullYear(),
		targetDate.getMonth(),
		targetDate.getDate(),
	)

	const diffInMs = nowStartOfDay.getTime() - targetStartOfDay.getTime()

	// If the date is in the future, return empty string or handle as needed
	if (diffInMs < 0) return ''

	const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
	const diffInMonths = Math.floor(diffInDays / 30)
	const diffInYears = Math.floor(diffInDays / 365)

	// Today
	if (diffInDays === 0) {
		return 'Published today'
	}

	// Yesterday
	if (diffInDays === 1) {
		return 'A day ago'
	}

	// Less than a month - show days
	if (diffInDays < 30) {
		return `${diffInDays} days ago`
	}

	// Less than a year - show months
	if (diffInDays < 365) {
		return diffInMonths === 1 ? '1 month ago' : `${diffInMonths} months ago`
	}

	// More than a year - show years
	return diffInYears === 1 ? '1 year ago' : `${diffInYears} years ago`
}

// Format date from ISO format to "Posted DD Month YYYY"
export const formatDate = (dateString: string): string => {
	try {
		const date = new Date(dateString)
		const day = date.getDate().toString().padStart(2, '0')
		const month = date.toLocaleString('en-AU', { month: 'long' })
		const year = date.getFullYear()
		return `Posted ${day} ${month} ${year}`
	} catch {
		// Return original string if parsing fails
		return dateString
	}
}
